import BaseService from './BaseService'

class ArPaymentService extends BaseService {
  constructor() {
    super('/ar-payments')
  }
}

export default new ArPaymentService()


